import { DateTime } from 'luxon';

export default function InvoiceStatus(invoice) {

    if (! invoice) return null;

    else if (invoice.amount_refunded == invoice.amount) return {
        id: 'refund',
        label: 'Refunded',
        class: 'warning'
    }

    else if (invoice.amount_refunded > 0) return {
        id: 'partial-refund',
        label: 'Partially Refunded',
        class: 'warning'
    }

    else if (invoice.amount_due <= 0) return {
        id: 'success',
        label: 'Completed',
        class: 'success'
    };

    else {
        const now = DateTime.local();
        const invoice_date = DateTime.isDateTime(invoice.invoice_by) ? invoice.invoice_by : DateTime.fromISO(invoice.invoice_by);
        const due_date = DateTime.isDateTime(invoice.due_by) ? invoice.due_by : DateTime.fromISO(invoice.due_by);
        const invoice_emailed_date = DateTime.isDateTime(invoice.invoice_email_sent_at) ? invoice.invoice_email_sent_at : DateTime.fromISO(invoice.invoice_email_sent_at);

        if (now < invoice_date) return {
            id: 'uninvoiced',
            label: 'Uninvoiced',
            class: 'warning'
        };

        if (now < due_date && invoice_emailed_date.isValid) return {
            id: 'invoice_sent',
            label: 'Invoice Sent',
            class: 'primary'
        };
        if (now < due_date) return {
            id: 'invoiced',
            label: 'Invoiced',
            class: 'primary'
        };

        else return {
            id: 'late',
            label: 'Past Due',
            class: 'error'
        };
    }
}
